// extracted by css-extract-rspack-plugin
export default {"Button":"DateShortcutPicker-module__Button___QmZOq"};